import { __extends } from "tslib";
import { Announced, classNamesFunction, getId, KeyCodes, SearchBox } from '@fluentui/react';
import { debounce } from 'lodash';
import React from 'react';
import { AutoSuggestDropdown } from './AutoSuggestDropdown';
import { searchBoxStyles } from './GlobalSearch.styles';
import { GetOnSearchDetailsView, RecentSearchTextsCount, SearchSuggestionCount, TotalSearchCategoryCount } from './GlobalSearch.types';
import { getSearchResultsAnnounce } from './GlobalSearch.utils';
var getClassNames = classNamesFunction();
var GlobalSearchBase = (function (_super) {
    __extends(GlobalSearchBase, _super);
    function GlobalSearchBase(props) {
        var _this = _super.call(this, props) || this;
        _this.searchRootRef = React.createRef();
        _this.searchInputRef = React.createRef();
        _this._autoSuggestionRef = React.createRef();
        _this.updateNumResultsDebounced = debounce(function (value) {
            _this.setState({ messageAnnouce: getSearchResultsAnnounce(value) });
        }, 10000);
        _this._getPlaceholderText = function () {
            if (_this.props.placeholder)
                return _this.props.placeholder;
            else if (_this.props.headerLabel)
                return 'Search ' + _this.props.headerLabel;
            return 'Search app';
        };
        _this._onSearchCallback = function (newSearchText) {
            if (newSearchText !== '') {
                _this.setState({
                    isOpen: false,
                    searchText: newSearchText,
                    showSearchSuggestions: true
                }, function () {
                    if (_this.props.onSearch) {
                        _this.props.onSearch(newSearchText);
                    }
                    if (_this.props.onShowMoreResultsCallback) {
                        _this.props.onShowMoreResultsCallback(newSearchText);
                    }
                });
            }
        };
        _this._onChangeCallback = function (event, newSearchText) {
            if (newSearchText !== '') {
                _this.setState({
                    isOpen: !GetOnSearchDetailsView(),
                    searchText: newSearchText,
                    showSearchSuggestions: true
                }, function () {
                    if (_this.props.onChange && !GetOnSearchDetailsView()) {
                        _this.props.onChange(event, newSearchText);
                    }
                    else if (_this.props.onShowMoreResultsCallback) {
                        _this.props.onShowMoreResultsCallback(newSearchText !== null && newSearchText !== undefined ? newSearchText : '');
                    }
                });
            }
        };
        _this._onBlurCallback = function () {
            if (_this.state.isOpen) {
                return;
            }
            if (GetOnSearchDetailsView()) {
                _this.setState({
                    isOpen: false,
                    showSearchSuggestions: false,
                    isError: false
                });
            }
            else {
                _this.setState({
                    isOpen: false,
                    searchText: '',
                    showSearchSuggestions: false,
                    isError: false
                });
            }
            if (_this.props.OnBlurCallback !== undefined) {
                _this.props.OnBlurCallback();
            }
        };
        _this._onClearCallback = function () {
            _this.setState({
                searchText: '',
                showSearchSuggestions: false,
                isError: false
            });
            if (_this.props && _this.props.onClear) {
                _this.props.onClear();
            }
        };
        _this._onFocusCallback = function () {
            var _a;
            if (!_this.state.isOpen) {
                _this.setState({
                    isOpen: true,
                    showSearchSuggestions: true
                });
                if (_this.props && _this.props.OnFocusCallback) {
                    _this.props.OnFocusCallback();
                }
                (_a = _this.searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        };
        _this._onCalloutDismissCallback = function () {
            _this.setState({
                isOpen: false,
                showSearchSuggestions: false,
                isError: false
            }, function () {
                _this._onBlurCallback();
            });
        };
        _this._closeAutosuggestDropdown = function () {
            _this.setState({
                isOpen: false,
                showSearchSuggestions: false,
                isError: false
            });
        };
        _this._onShowMoreResultsClick = function () {
            _this.setState({
                isOpen: false
            }, function () {
                if (_this.props.onShowMoreResultsCallback && _this.state.searchText) {
                    _this.props.onShowMoreResultsCallback(_this.state.searchText);
                }
            });
        };
        _this._onClickSuggestionItem = function (item, category) {
            _this.setState({
                isOpen: false
            }, function () {
                if (_this.props.OnClickSuggestionItem) {
                    _this.props.OnClickSuggestionItem(item, category);
                }
            });
        };
        _this._onDropdownKeyDown = function (ev) {
            var _a, _b;
            var isOpen = _this.state.isOpen;
            switch (ev.which) {
                case KeyCodes.enter:
                    _this.setState({
                        isOpen: !isOpen
                    });
                    break;
                case KeyCodes.escape:
                    if (!isOpen) {
                        return;
                    }
                    _this.setState({
                        isOpen: false
                    });
                    break;
                case KeyCodes.up:
                    if (isOpen) {
                        _this.setState({ isOpen: false });
                        break;
                    }
                    return;
                case KeyCodes.down:
                    if (isOpen) {
                        (_a = _this._autoSuggestionRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                    else {
                        (_b = _this.searchInputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                    }
                    ev.stopPropagation();
                    ev.preventDefault();
                    break;
                case KeyCodes.home:
                    break;
                case KeyCodes.end:
                    break;
                case KeyCodes.space:
                    break;
                case KeyCodes.tab:
                    break;
                default:
            }
        };
        _this._id = getId();
        _this._autoSuggestDropdownId = 'autoSuggestionDropDown' + _this._id;
        _this.state = {
            isOpen: false,
            searchText: undefined,
            showSearchSuggestions: false,
            isError: _this.props.isError !== null && _this.props.isError !== undefined ? _this.props.isError : false,
            messageAnnouce: ''
        };
        return _this;
    }
    GlobalSearchBase.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _a, _b, _c, _d;
        if (this.props.isError !== nextProps.isError || (!GetOnSearchDetailsView() && !this.state.isOpen)) {
            this.setState({
                isError: nextProps.isError !== null && nextProps !== undefined ? nextProps.isError : false,
                searchText: !GetOnSearchDetailsView() && !this.state.isOpen ? '' : this.state.searchText
            });
        }
        var prevNumSuggestions = (_b = (_a = this.props.suggestions) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        var curNumSuggestions = (_d = (_c = nextProps.suggestions) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
        if (prevNumSuggestions !== curNumSuggestions) {
            this.setState({ messageAnnouce: getSearchResultsAnnounce(curNumSuggestions) });
        }
    };
    GlobalSearchBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a, _b;
        if (prevState.searchText !== this.state.searchText) {
            if (this.state.messageAnnouce !== '') {
                this.setState({ messageAnnouce: '' });
            }
            this.updateNumResultsDebounced((_b = (_a = this.props.suggestions) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
        }
    };
    GlobalSearchBase.prototype.render = function () {
        var _a = this.props, _b = _a.id, id = _b === void 0 ? 'searchbox' : _b, isLoading = _a.isLoading, recentSearchTexts = _a.recentSearchTexts, suggestions = _a.suggestions, errorMessage = _a.errorMessage, onEscape = _a.onEscape, disabled = _a.disabled, styles = _a.styles, theme = _a.theme, iconProps = _a.iconProps;
        var _c = this.state, searchText = _c.searchText, isOpen = _c.isOpen, showSearchSuggestions = _c.showSearchSuggestions, isError = _c.isError;
        var _theme = theme;
        var classNames = getClassNames(styles, { theme: _theme });
        return (React.createElement("div", { role: "search" },
            this.state.searchText !== '' && React.createElement(Announced, { "aria-live": "polite", message: this.state.messageAnnouce }),
            React.createElement("div", { ref: this.searchRootRef, onFocus: this._onFocusCallback, onBlur: this._onBlurCallback, "aria-owns": isOpen ? this._autoSuggestDropdownId : undefined, "data-is-focusable": true, onKeyDown: this._onDropdownKeyDown, className: classNames.root, id: 'coherenceSearchBase', "aria-label": this._getPlaceholderText(), "aria-live": "polite" },
                React.createElement("label", { htmlFor: id, style: { display: 'none' } }, this._getPlaceholderText()),
                React.createElement(SearchBox, { id: id, componentRef: this.searchInputRef, disabled: disabled, placeholder: this._getPlaceholderText(), onSearch: this._onSearchCallback, onChange: this._onChangeCallback, onClear: this._onClearCallback, onEscape: onEscape, styles: searchBoxStyles(_theme), value: searchText, className: classNames.searchbox, iconProps: iconProps })),
            isOpen ? (React.createElement(AutoSuggestDropdown, { target: this.searchRootRef, id: this._autoSuggestDropdownId, showSearchSuggestions: showSearchSuggestions, recentSearchTexts: recentSearchTexts, suggestions: suggestions !== null && suggestions !== undefined ? suggestions : [], isLoading: isLoading, OnCalloutDismissCallback: this._onCalloutDismissCallback, OnClickSuggestionItem: this._onClickSuggestionItem, OnShowMoreResults: this._onShowMoreResultsClick, isError: isError, errorMessage: errorMessage, recentSearchTextsCount: RecentSearchTextsCount, searchCategoryCount: TotalSearchCategoryCount, suggestionsCount: SearchSuggestionCount, CloseAutosuggest: this._closeAutosuggestDropdown, componentRef: this._autoSuggestionRef, styles: classNames, theme: _theme })) : (React.createElement(React.Fragment, null))));
    };
    return GlobalSearchBase;
}(React.Component));
export { GlobalSearchBase };
//# sourceMappingURL=GlobalSearch.base.js.map